
import { tsvParse } from  "d3-dsv";
import { timeParse } from "d3-time-format";

function parseData(parse) {
	return function(d) {
		d.date = parse(d.date);
		d.open = +d.open;
		d.high = +d.high;
		d.low = +d.low;
		d.close = +d.close;
		d.volume = +d.volume;
		return d;
	};
}


const parseDate = timeParse("%Y-%m-%d");

export function getData(variable, level) {
  let apiUrl = level === '' ? `https://www.buysellorhold.com/api/history/tsv?symbol=${variable}` : `https://www.buysellorhold.com/api/history/tsv?symbol=${variable}&level=${level}`;
  const promiseMSFT = fetch(apiUrl)
		.then(response => response.text())
        .then(data => tsvParse(data, parseData(parseDate)))
	return promiseMSFT;
}
export function getAdditionalData(variable, level) {
  let apiUrl = level === '' ? `https://www.buysellorhold.com/api/data?sym=${variable}` : `https://www.buysellorhold.com/api/data?sym=${variable}&level=${level}`;
  const promiseMark = fetch(apiUrl)
    .then(response => response.text())
    .then(data => JSON.parse(data))
	return promiseMark;
}

export function getMRIData() {
  const promisMRI = fetch(`https://www.buysellorhold.com/api/mri`)
		.then(response => response.text())
        .then(data => JSON.parse(data))
	return promisMRI;
}

export function getDailyOpinionData(variable, level, day)
{
    var date = `${day.getMonth() + 1}/${day.getDate()}/${day.getFullYear()}`;
    let apiUrl = level === '' ? `https://www.buysellorhold.com/api/data?sym=${variable}&date=${date}` : `https://www.buysellorhold.com/api/data?sym=${variable}&level=${level}&date=${date}`;
    const promiseMark = fetch(apiUrl)
        .then(response => response.text())
        .then(data => JSON.parse(data));
	return promiseMark;
}